// API Configuration
export const API_URL = 'https://api.lifeshare.app/api/v1';

// Helper to build full URL
export const apiUrl = (endpoint: string) => `${API_URL}${endpoint}`;

// Helper for file URLs (avatars, etc)
export const fileUrl = (path: string) => {
  if (path.startsWith('/uploads')) {
    return `https://api.lifeshare.app${path}`;
  }
  return path;
};

export default { API_URL, apiUrl, fileUrl };
